{
  "familyId": "GET-NEGATIEF-MIN",
  "questions": [
    {
      "id": "GET-NEGATIEF-MIN-001",
      "familyId": "GET-NEGATIEF-MIN",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_aftrekken",
      "questionType": "multiple_choice",
      "question": "Wat is 3 − 8?",
      "options": ["−5", "5", "−11", "11"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": -6,
            "end": 4,
            "marked": [3],
            "step": 1,
            "label": "Begin bij 3 op de getallenlijn"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meer aftrekken dan je hebt",
            "content": "Als je meer aftrekt dan je hebt, ga je onder nul. Begin bij 3 en ga 8 stappen naar links: je komt op −5. Het minteken betekent 'onder nul'.",
            "icon": "lightbulb"
          }
        },
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": -6,
            "end": 4,
            "marked": [3],
            "highlight": [-5],
            "arrows": [{"from": 3, "to": -5, "label": "8 stappen naar links"}],
            "step": 1,
            "label": "3 − 8 = −5: je komt 5 onder nul"
          }
        }
      ],
      "conceptId": "negatief_min_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.78,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.negatief-min-altijd-positief", "label": "Verschil altijd positief opvatten", "optionIndex": 1 },
          { "id": "get.negatief-min-optellen-min", "label": "Optellen i.p.v. aftrekken met minteken", "optionIndex": 2 },
          { "id": "get.negatief-min-optellen-positief", "label": "Optellen i.p.v. aftrekken", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Begin bij 3 op de getallenlijn en ga 8 stappen naar links. Je gaat voorbij 0 en komt op −5. Je hebt 3, maar trekt 8 af — dat is 5 meer dan je hebt, dus je komt 5 onder nul.",
        "solutionSteps": [
          "Begin bij 3 op de getallenlijn",
          "Ga 8 stappen naar links (aftrekken)",
          "3 → 2 → 1 → 0 → −1 → −2 → −3 → −4 → −5",
          "Antwoord: 3 − 8 = −5"
        ],
        "distractorExplanations": {
          "0": "Goed! 3 − 8 = −5. Je komt 5 onder nul uit.",
          "1": "Je dacht waarschijnlijk dat het verschil altijd positief is. Het verschil tussen 3 en 8 is inderdaad 5, maar omdat je meer aftrekt dan je hebt, wordt het antwoord negatief: −5. Onthoud: als je meer aftrekt dan je hebt, ga je onder nul.",
          "2": "Je dacht waarschijnlijk dat je de getallen moet optellen en dan een minteken ervoor zetten. 3 + 8 = 11, maar 3 − 8 is aftrekken, niet optellen. Onthoud: bij aftrekken ga je naar links op de getallenlijn, niet naar rechts.",
          "3": "Je dacht waarschijnlijk dat je de getallen moet optellen. 3 + 8 = 11, maar de vraag is 3 − 8 (aftrekken). Onthoud: het minteken betekent 'ga naar links op de getallenlijn'."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-MIN-002",
      "familyId": "GET-NEGATIEF-MIN",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_aftrekken",
      "questionType": "multiple_choice",
      "question": "Wat is −4 − 6?",
      "options": ["−10", "−2", "2", "10"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": -11,
            "end": 0,
            "marked": [-4],
            "step": 1,
            "label": "Begin bij −4 op de getallenlijn"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Aftrekken van een negatief getal",
            "content": "Als je al onder nul staat en nog meer aftrekt, ga je nóg verder naar links. −4 − 6: begin bij −4 en ga 6 stappen naar links → −10.",
            "icon": "lightbulb"
          }
        },
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": -11,
            "end": 0,
            "marked": [-4],
            "highlight": [-10],
            "arrows": [{"from": -4, "to": -10, "label": "6 stappen naar links"}],
            "step": 1,
            "label": "−4 − 6 = −10: verder onder nul"
          }
        }
      ],
      "conceptId": "negatief_min_positief",
      "variantIndex": 2,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.negatief-min-min-verschil", "label": "Min van min als verschil gerekend", "optionIndex": 1 },
          { "id": "get.negatief-min-min-wegstrepen", "label": "Mintekens onterecht wegstrepen", "optionIndex": 2 },
          { "id": "get.negatief-min-teken-vergeten", "label": "Negatief teken bij uitkomst vergeten", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Begin bij −4 op de getallenlijn en ga 6 stappen naar links. −4 − 6 = −10. Als je al onder nul staat en nog meer aftrekt, ga je nóg verder naar links. Je kunt het ook zo zien: 4 + 6 = 10, en beide zijn negatief, dus −10.",
        "solutionSteps": [
          "Begin bij −4 op de getallenlijn",
          "Ga 6 stappen naar links (aftrekken)",
          "−4 − 6 = −(4 + 6) = −10",
          "Antwoord: −10"
        ],
        "distractorExplanations": {
          "0": "Goed! −4 − 6 = −10. Je gaat verder naar links op de getallenlijn.",
          "1": "Je dacht waarschijnlijk dat je 6 − 4 = 2 moet rekenen en dan een minteken ervoor zetten. Maar −4 − 6 betekent: begin bij −4 en ga 6 verder naar links. Dat is −(4 + 6) = −10. Onthoud: als je van een negatief getal aftrekt, tel je de afstanden op.",
          "2": "Je dacht waarschijnlijk dat de mintekens tegen elkaar wegvallen. Maar −4 − 6 is niet hetzelfde als 6 − 4. Je begint bij −4 en gaat nóg 6 naar links: −10. Onthoud: aftrekken van een negatief getal maakt het nóg negatiever.",
          "3": "Je dacht waarschijnlijk dat je de getallen gewoon optelt: 4 + 6 = 10. Dat klopt bijna — maar het antwoord is negatief: −10. Onthoud: als je bij een negatief getal aftrekt, blijf je onder nul."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-MIN-003",
      "familyId": "GET-NEGATIEF-MIN",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_aftrekken",
      "questionType": "multiple_choice",
      "question": "Wat is −2 − (−7)?",
      "options": ["5", "−9", "−5", "9"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": -3,
            "end": 6,
            "marked": [-2],
            "step": 1,
            "label": "Begin bij −2 op de getallenlijn"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Min min = plus",
            "content": "Twee mintekens na elkaar worden een plus. −2 − (−7) = −2 + 7. Begin bij −2 en ga 7 stappen naar rechts: je komt op 5.",
            "icon": "lightbulb"
          }
        },
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": -3,
            "end": 6,
            "marked": [-2],
            "highlight": [5],
            "arrows": [{"from": -2, "to": 5, "label": "7 stappen naar rechts (min min = plus)"}],
            "step": 1,
            "label": "−2 − (−7) = −2 + 7 = 5"
          }
        }
      ],
      "conceptId": "negatief_min_negatief",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.negatief-min-min-niet-plus", "label": "Dubbele min niet als plus herkend", "optionIndex": 1 },
          { "id": "get.negatief-min-uitkomst-altijd-negatief", "label": "Uitkomst altijd negatief verondersteld", "optionIndex": 2 },
          { "id": "get.negatief-min-startgetal-verkeerd", "label": "Startgetal als positief opgevat", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Twee mintekens na elkaar worden een plus: −2 − (−7) = −2 + 7. Begin bij −2 op de getallenlijn en ga 7 stappen naar rechts. −2 + 7 = 5.",
        "solutionSteps": [
          "Herken: min min = plus",
          "−2 − (−7) = −2 + 7",
          "Begin bij −2, ga 7 naar rechts",
          "−2 + 7 = 5"
        ],
        "distractorExplanations": {
          "0": "Goed! −2 − (−7) = −2 + 7 = 5. Min min wordt plus!",
          "1": "Je dacht waarschijnlijk dat je de getallen moet optellen met een minteken: −(2 + 7) = −9. Maar het dubbele minteken maakt er een plus van: −2 − (−7) = −2 + 7 = 5. Onthoud: min min = plus, dus je gaat naar rechts op de getallenlijn.",
          "2": "Je dacht waarschijnlijk dat het antwoord negatief moet zijn. Maar −2 + 7 = 5 (positief), want 7 is groter dan 2. Onthoud: als je genoeg naar rechts gaat, kom je boven nul uit.",
          "3": "Je dacht waarschijnlijk dat −2 positief wordt (2) en dan 2 + 7 = 9. Maar je begint bij −2, niet bij +2. Onthoud: alleen het dubbele minteken (− −) verandert, het startgetal blijft −2."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-MIN-004",
      "familyId": "GET-NEGATIEF-MIN",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_aftrekken",
      "questionType": "thermometer_slider",
      "question": "De temperatuur is −3°C. 's Nachts daalt het 9 graden. Wat is de temperatuur 's nachts?",
      "options": [],
      "correctAnswer": -12,
      "data": {
        "minTemp": -20,
        "maxTemp": 10,
        "startTemp": -3,
        "step": 1,
        "unit": "C"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "thermometer",
          "showWhen": "wrong",
          "data": {
            "minTemp": -20,
            "maxTemp": 10,
            "currentTemp": -3,
            "targetTemp": -12,
            "unit": "C",
            "label": "Van −3°C naar −12°C: 9 graden daling"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Temperatuurdaling = aftrekken",
            "content": "De temperatuur daalt 9 graden. Dat betekent: −3 − 9. Begin bij −3 en ga 9 stappen naar beneden op de thermometer. Je komt op −12°C.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "negatief_min_context",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "De temperatuur begint bij −3°C en daalt 9 graden. Daling betekent aftrekken: −3 − 9. Begin bij −3 en ga 9 stappen naar beneden op de thermometer: −3 − 9 = −12°C.",
        "solutionSteps": [
          "Begint bij −3°C",
          "Daling van 9 graden = aftrekken: −3 − 9",
          "−3 − 9 = −(3 + 9) = −12",
          "Antwoord: −12°C"
        ]
      }
    },
    {
      "id": "GET-NEGATIEF-MIN-005",
      "familyId": "GET-NEGATIEF-MIN",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_aftrekken",
      "questionType": "thermometer_slider",
      "question": "De thermometer wijst −5°C aan. In de nacht daalt de temperatuur 7 graden. Wat is de temperatuur 's ochtends?",
      "options": [],
      "correctAnswer": -12,
      "data": {
        "minTemp": -20,
        "maxTemp": 10,
        "startTemp": -5,
        "step": 1,
        "unit": "C"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "thermometer",
          "showWhen": "wrong",
          "data": {
            "minTemp": -20,
            "maxTemp": 10,
            "currentTemp": -5,
            "targetTemp": -12,
            "unit": "C",
            "label": "Van −5°C naar −12°C: 7 graden daling"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Temperatuurdaling aflezen",
            "content": "De thermometer wijst −5°C aan. Daling van 7 graden = aftrekken: −5 − 7 = −12°C. Je gaat verder onder nul op de thermometer.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "negatief_min_thermometer",
      "variantIndex": 5,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "De thermometer wijst −5°C aan. De temperatuur daalt 7 graden: −5 − 7 = −12°C. Je staat al 5 graden onder nul en gaat nog 7 graden verder naar beneden. Dat is −(5 + 7) = −12°C.",
        "solutionSteps": [
          "Lees de thermometer af: −5°C",
          "Daling van 7 graden = aftrekken: −5 − 7",
          "−5 − 7 = −(5 + 7) = −12°C",
          "Check: van −12 naar −5 is 7 graden stijging ✓"
        ]
      }
    }
  ]
}